<template>
    <span class="badge" v-if="count">{{ count }}</span>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('cart');

export default {
  computed: mapGetters(['count'])
}
</script>
